import { Component, OnInit } from '@angular/core';
import { Multilingual } from '@core/utilities/multilingual';
import { LayoutService } from '@common/services/layout.service';

@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private layout: LayoutService) { }

  ngOnInit(): void {
    this.layout.title = Multilingual.getText('Bảng giá sản phẩm');
  }
}
